import React from "react";
import Slider, { Range } from "rc-slider";

import { getVehicleModel } from "../../../model/car";

import { IcBack, IcAdvance, IcHideAdvance } from "../../common/svg";

import "rc-slider/assets/index.css";

const handleSliderSt = [{ background: "#5fcf86", border: "3px solid #fff", cursor: "pointer", boxShadow: "5px 5px 12px rgba(0,0,0,.15)", height: '28px', width: '28px', transform: 'translate(-50%, -45%)!important'}, { background: "#5fcf86", border: "3px solid #fff", cursor: "pointer", boxShadow: "5px 5px 12px rgba(0,0,0,.15)", height: '28px', width: '28px', transform: 'translate(-50%, -45%)!important' }]

const trackSt = [{ background: "#5fcf86", height: "4px",  borderRadius: "16px", cursor: "pointer" }]

const railSt = { background: "#AAAAAA", height: "4px", borderRadius: "16px", cursor: "pointer" }

class CSFilterScreen extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			showAdvance: false,
		};

		
	}

	componentDidMount() {
	
	

		if (this.props.customFilterConfig) {
			const featuresAll = this.props.customFilterConfig.allFeatures;
			const features = this.props.filter.features;
			for (var i = 0; i < featuresAll.length; ++i) {
				var checked = false;
				if (features) {
					for (var j = 0; j < features.length; ++j) {
						if (featuresAll[i].id === features[j]) {
							checked = true;
							break;
						}
					}
				}

				featuresAll[i].checked = checked;
			}
		}
	}


	resetFilter = () => {
		this.props.resetFilter();
	};

	onSortChange = (event) => {
		const filter = {
			...this.props.filter,
			sort: event.target.value,
		};
		this.props.setFilter(filter);
		this.props.searchCar(filter);
	};

	onPriceRangeChange = (range) => {
		const filter = {
			...this.props.filter,
			minPrice: range[0],
			maxPrice: range[1],
		};

		this.props.setFilter(filter);
	};

	onPriceRangeAfterChange = (range) => {
		const filter = {
			...this.props.filter,
			minPrice: range[0],
			maxPrice: range[1],
		};

		this.props.setFilter(filter);
		this.props.searchCar(filter);
	};

	onLimitKMRangeChange = (range) => {
		const filter = {
			...this.props.filter,
			limitKM: range,
		};
		this.props.setFilter(filter);
	};

	onLimitKMRangeChangeComplete = (range) => {
		const filter = {
			...this.props.filter,
			limitKM: range,
		};
		this.props.setFilter(filter);
		this.props.searchCar(filter);
	};

	onLimitKMPriceRangeChange = (range) => {
		const filter = {
			...this.props.filter,
			limitKMPrice: range,
		};
		this.props.setFilter(filter);
	};

	onLimitKMPriceRangeChangeComplete = (range) => {
		const filter = {
			...this.props.filter,
			limitKMPrice: range,
		};
		this.props.setFilter(filter);
		this.props.searchCar(filter);
	};

	onDPriceRangeChange = (range) => {
		const filter = {
			...this.props.filter,
			dPrice: range,
		};
		this.props.setFilter(filter);
	};

	onDPriceRangeChangeComplete = (range) => {
		const filter = {
			...this.props.filter,
			dPrice: range,
		};
		this.props.setFilter(filter);
		this.props.searchCar(filter);
	};

	onPVerifiedChange = (event) => {
		const filter = {
			...this.props.filter,
			pVerified: event.target.checked,
		};
		this.props.setFilter(filter);
		this.props.searchCar(filter);
	};

	onVTypeChange = (event) => {
		const { vehicleTypes } = this.props;
		const vehicleTypeId = event.target.value;
		const vehicleMake = this.props.filter.vehicleMake;
		let vehicleType = [];

		if (this.props.filter.vehicleType) {
			vehicleType = this.props.filter.vehicleType.slice();
		}

		if (event.target.checked) {
			vehicleType.push(vehicleTypeId);
		} else {
			vehicleType = vehicleType.filter((vType) => {
				return vType !== vehicleTypeId;
			});
		}

		for (var i = 0; i < vehicleTypes.length; ++i) {
			var checked = false;
			if (vehicleType) {
				for (var j = 0; j < vehicleType.length; ++j) {
					if (vehicleTypes[i].id === vehicleType[j]) {
						checked = true;
						break;
					}
				}
			}

			vehicleTypes[i].checked = checked;
		}

		if (vehicleMake > 0) {
			getVehicleModel(vehicleType, vehicleMake, true).then((resp) => {
				if (resp.data.data) {
					this.setState({
						vehicleModels: resp.data.data.vehicleModels,
					});
					const filter = {
						...this.props.filter,
						vehicleType: vehicleType,
						vehicleModel: [],
					};
					this.props.setFilter(filter);
					this.props.searchCar(filter);
				}
			});
		} else {
			this.setState({
				vehicleModels: null,
			});
			const filter = {
				...this.props.filter,
				vehicleType: vehicleType,
				vehicleModel: [],
			};
			this.props.setFilter(filter);
			this.props.searchCar(filter);
		}
	};

	onVMakeChange = (e) => {
		const vehicleMake = Number(e);
		if (vehicleMake > 0) {
			const vehicleType = this.props.filter.vehicleType;
			getVehicleModel(vehicleType, vehicleMake, true).then((resp) => {
				if (resp.data.data) {
					this.setState({
						vehicleModels: resp.data.data.vehicleModels,
					});
					const filter = {
						...this.props.filter,
						vehicleMake: vehicleMake,
						vehicleModel: [],
					};
					this.props.setFilter(filter);
					this.props.searchCar(filter);
				}
			});
		} else {
			this.setState({
				vehicleModels: null,
			});
			const filter = {
				...this.props.filter,
				vehicleMake: 0,
				vehicleModel: [],
			};
			this.props.setFilter(filter);
			this.props.searchCar(filter);
		}
	};

	onVModelChange = (event) => {
		let vehicleModel = [];
		const { vehicleModels } = this.state;
		const vehicleModelId = event.target.value;

		if (this.props.filter.vehicleModel) {
			vehicleModel = this.props.filter.vehicleModel.slice();
		}

		if (event.target.checked) {
			vehicleModel.push(vehicleModelId);
		} else {
			vehicleModel = vehicleModel.filter((vModel) => {
				return vModel !== vehicleModelId;
			});
		}

		for (var i = 0; i < vehicleModels.length; ++i) {
			var checked = false;
			if (vehicleModel) {
				for (var j = 0; j < vehicleModel.length; ++j) {
					if (vehicleModels[i].id === vehicleModel[j]) {
						checked = true;
						break;
					}
				}
			}

			vehicleModels[i].checked = checked;
		}

		const filter = {
			...this.props.filter,
			vehicleModel: vehicleModel,
		};
		this.props.setFilter(filter);
		this.props.searchCar(filter);
	};

	onTransmissionChange = (event) => {
		const filter = {
			...this.props.filter,
			transmission: event.target.value,
		};
		this.props.setFilter(filter);
		this.props.searchCar(filter);
	};

	onRadiusRangeChange = (range) => {
		const filter = {
			...this.props.filter,
			radius: range / 1.60934,
		};
		this.props.setFilter(filter);
	};

	onRadiusRangeChangeComplete = (range) => {
		const filter = {
			...this.props.filter,
			radius: range / 1.60934,
		};
		this.props.setFilter(filter);
		this.props.searchCar(filter);
	};

	onFuelChange = (event) => {
		const filter = {
			...this.props.filter,
			fuel: event.target.value,
		};
		this.props.setFilter(filter);
		this.props.searchCar(filter);
	};

	onFuelCRangeChange = (range) => {
		const filter = {
			...this.props.filter,
			fuelC: range,
		};
		this.props.setFilter(filter);
	};

	onFuelCRangeChangeComplete = (range) => {
		const filter = {
			...this.props.filter,
			fuelC: range,
		};
		this.props.setFilter(filter);
		this.props.searchCar(filter);
	};

	onYearRangeChange = (range) => {
		const filter = {
			...this.props.filter,
			minYear: range[0],
			maxYear: range[1],
		};
		this.props.setFilter(filter);
	};

	onYearRangeAfterChange = (range) => {
		const filter = {
			...this.props.filter,
			minYear: range[0],
			maxYear: range[1],
		};

		this.props.setFilter(filter);
		this.props.searchCar(filter);
	};

	onSeatRangeChange = (range) => {
		const filter = {
			...this.props.filter,
			minSeat: range[0],
			maxSeat: range[1],
		};
		this.props.setFilter(filter);
	};

	onSeatRangeAfterChange = (range) => {
		const filter = {
			...this.props.filter,
			minSeat: range[0],
			maxSeat: range[1],
		};
		this.props.setFilter(filter);
		this.props.searchCar(filter);
	};

	onFeaturesChange = (event) => {
		var features = [];
		if (this.props.filter.features) {
			features = this.props.filter.features.slice();
		}

		const featureId = event.target.value;
		if (event.target.checked) {
			features.push(featureId);
		} else {
			features = features.filter(function (feature) {
				return feature !== featureId;
			});
		}

		const featuresAll = this.props.customFilterConfig.allFeatures;
		for (var i = 0; i < featuresAll.length; ++i) {
			var checked = false;
			if (features) {
				for (var j = 0; j < features.length; ++j) {
					if (featuresAll[i].id === features[j]) {
						checked = true;
						break;
					}
				}
			}

			featuresAll[i].checked = checked;
		}

		const filter = {
			...this.props.filter,
			features: features,
		};

		this.props.setFilter(filter);
		this.props.searchCar(filter);
	};

	onHandleCheckedBoxChange = (event) => {
		const filter = {
			...this.props.filter,
			[event.target.name]: event.target.checked,
		};
		this.props.setFilter(filter);
		this.props.searchCar(filter);
	};

	toggleShowAdvance = () => {
		this.setState({
			showAdvance: !this.state.showAdvance,
		});
	};

	onHide = () => {
		this.props.hide();
	};

	render() {
		const {
			viewModes,
			viewMode,
			defPriceRange,
			defLimitKMRange,
			defLimitKMPriceRange,
			defDPriceRange,
			defFuelCRange,
			defSeatRange,
			defYearRange,
			defRadiusRange,
			filter,
			counters,
			totalCar,
			customFilterConfig,
			vehicleTypes,
			vehicleMakes,
			isShow,
		} = this.props;

		const { vehicleMake, vehicleModel } = filter;

		const mode = viewMode;

		const { vehicleModels, showAdvance } = this.state;
		var i, j, counter;

		if (counters) {
			if (vehicleTypes) {
				for (i = 0; i < vehicleTypes.length; ++i) {
					counter = 0;
					if (counters.vehicleTypes) {
						for (j = 0; j < counters.vehicleTypes.length; ++j) {
							if (vehicleTypes[i].id === counters.vehicleTypes[j].id) {
								counter = counters.vehicleTypes[j].counter;
								break;
							}
						}
					}
					vehicleTypes[i].counter = counter;
				}
			}

			if (vehicleMakes) {
				for (i = 0; i < vehicleMakes.length; ++i) {
					counter = 0;
					if (counters.vehicleMakes) {
						for (j = 0; j < counters.vehicleMakes.length; ++j) {
							if (vehicleMakes[i].id === counters.vehicleMakes[j].id) {
								counter = counters.vehicleMakes[j].counter;
								break;
							}
						}
					}
					vehicleMakes[i].counter = counter;
				}
			}
			if (vehicleModels) {
				for (i = 0; i < vehicleModels.length; ++i) {
					counter = 0;
					if (counters.vehicleModels) {
						for (j = 0; j < counters.vehicleModels.length; ++j) {
							if (vehicleModels[i].id === counters.vehicleModels[j].id) {
								counter = counters.vehicleModels[j].counter;
								break;
							}
						}
					}
					vehicleModels[i].counter = counter;
				}
			}
		}

		const sortValue = customFilterConfig && customFilterConfig.sort ? customFilterConfig.sort : "pl";
		var minPrice;
		var maxPrice;
	
        minPrice = customFilterConfig && customFilterConfig.minPrice ? customFilterConfig.minPrice / 1000 : defPriceRange.min;
        maxPrice = customFilterConfig && customFilterConfig.maxPrice ? customFilterConfig.maxPrice / 1000 : defPriceRange.max;
		
		const minLimitKM = defLimitKMRange.min;
		const maxLimitKM =
			customFilterConfig && customFilterConfig.maxLimitKM ? customFilterConfig.maxLimitKM + 50 : defLimitKMRange.max;
		const minLimitKMPrice = defLimitKMPriceRange.min;
		const maxLimitKMPrice =
			customFilterConfig && customFilterConfig.maxLimitKMPrice
				? customFilterConfig.maxLimitKMPrice / 1000 + 5
				: defLimitKMPriceRange.max;
		const minDPrice = defDPriceRange.min;
        const maxDPrice = customFilterConfig && customFilterConfig.maxDeliveryPrice
					? customFilterConfig.maxDeliveryPrice / 1000
					: defDPriceRange.max;
		// var maxDPrice;
		// if (this.isSD) {
		// 	maxDPrice =
		// 		customFilterConfig && customFilterConfig.maxDeliveryPrice
		// 			? customFilterConfig.maxDeliveryPrice / 1000
		// 			: defDPriceRange.max;
		// } else {
		// 	maxDPrice =
		// 		customFilterConfig && customFilterConfig.wdMaxDeliveryPrice
		// 			? customFilterConfig.wdMaxDeliveryPrice / 1000
		// 			: defDPriceRange.max;
		// }
		const minFuelC =
			customFilterConfig && customFilterConfig.minFuelC ? customFilterConfig.minFuelC : defFuelCRange.min;
		const maxFuelC =
			customFilterConfig && customFilterConfig.maxFuelC ? customFilterConfig.maxFuelC : defFuelCRange.max;
		const minSeat = customFilterConfig && customFilterConfig.seatMin ? customFilterConfig.seatMin : defSeatRange.min;
		const maxSeat = customFilterConfig && customFilterConfig.seatMax ? customFilterConfig.seatMax : defSeatRange.max;
		const minYear = customFilterConfig && customFilterConfig.yearMin ? customFilterConfig.yearMin : defYearRange.min;
		const maxYear = customFilterConfig && customFilterConfig.yearMax ? customFilterConfig.yearMax : defYearRange.max;
		const minRadius =
			customFilterConfig && customFilterConfig.minRadius ? customFilterConfig.minRadius : defRadiusRange.min;
		const maxRadius =
			customFilterConfig && customFilterConfig.maxRadius ? customFilterConfig.maxRadius : defRadiusRange.max;

		const hasFilter =
			filter.minPrice > minPrice ||
			filter.maxPrice < maxPrice ||
			(filter.vehicleType && filter.vehicleType.length > 0) ||
			filter.vehicleMake != "0" ||
			filter.vehicleModel.length > 0 ||
			filter.minSeat > minSeat ||
			filter.maxSeat < maxSeat ||
			filter.minYear > minYear ||
			filter.maxYear < maxYear ||
			filter.instantBooking === true ||
			filter.directDelivery === true ||
			filter.dPrice < maxDPrice ||
			filter.transmission != "0" ||
			// filter.features.length > 0 ||
			filter.fuel != "0" ||
			filter.fuelC > minFuelC ||
			filter.limitKM < maxLimitKM ||
			filter.limitKMPrice < maxLimitKMPrice ||
			filter.radius * 1.60934 < maxRadius ||
			filter.sort != 'pl' ||
			filter.supportIns === true ||
			filter.ownerHostFiveStar === true ||
			filter.nonMortgage === true
			

		return (
			<div className={`filter-toggle ${isShow ? "" : "move-left"}`}>
				<div className="m-container">
					<div className="toggle-header">
						<div className="space" />
						<h6>Bộ lọc</h6>
						<div className="back" onClick={this.onHide}>×</div>
						{/* <a className="text-danger" onClick={this.resetFilter}>
							Đặt lại
						</a> */}
					</div>
					<div className="toggle-footer">
						<a className="text-danger font-14" onClick={this.resetFilter}>
							<strong>Đặt lại</strong>
						</a>
						<a className="btn btn--s btn-primary" onClick={this.onHide}>
							Tìm xe
						</a>
					</div>

					<div className="group-item">
						<p className="title">Sắp xếp</p>
				
                        <div className="line-form">
                            <div className="custom-select">
                                <select onChange={this.onSortChange} value={filter.sort}>
                                    {customFilterConfig &&
                                        customFilterConfig.sort.map((option) => {
											if (option.id !== "dt") {
												return <option key={option.id} value={option.id}>
													{option.name}
												</option>
											}
										})}
                                </select>
                            </div>
                        </div>
						
					</div>

					<div className="line-page" />

					{/* <div className="group-item">
						<p className="title">Mức giá</p>
						<div className="wrap-item">
							<div className="range-slider">
								<Range
									step={50}
									min={minPrice}
									max={maxPrice}
									value={[filter.minPrice, filter.maxPrice]}
									allowCross={false}
									pushable={true}
									handleStyle={handleSliderSt}
									trackStyle={trackSt}
									railStyle={railSt}
									onChange={this.onPriceRangeChange}
									onAfterChange={this.onPriceRangeAfterChange}
								/>
						
							</div>
							<div className="range-value two-item">
								<div className="range-value__item">
									<span>Giá thấp nhất</span>
									<p>{filter.minPrice > minPrice ?  filter.minPrice + "K" : minPrice + "K"} </p>
								</div>
								<div className="line" />
								<div className="range-value__item">
									<span>Giá cao nhất</span>
									<p>{filter.maxPrice < maxPrice ?  filter.maxPrice + "K" : maxPrice + "K"}</p>
								</div>
							</div>
						</div>
					</div> */}


					{/* <div className="line-page" /> */}

					<div className="group-item">
						<p className="title">Nhiên liệu</p>
						<div className="wrap-item">
							<div className="custom-radio">
								<input
									type="radio"
									id="rm_fuel"
									name="rdFuel"
									value="0"
									onChange={this.onFuelChange}
									checked={filter.fuel == 0}
								/>
								<label htmlFor="rm_fuel">Tất cả</label>
							</div>
							<div className="custom-radio">
								<input
									type="radio"
									id="rm_fuel1"
									name="rdFuel"
									value="1"
									onChange={this.onFuelChange}
									checked={filter.fuel == 1}
								/>
								<label htmlFor="rm_fuel1">Xăng</label>
							</div>
							<div className="custom-radio">
								<input
									type="radio"
									id="rm_fuel2"
									name="rdFuel"
									value="2"
									onChange={this.onFuelChange}
									checked={filter.fuel == 2}
								/>
								<label htmlFor="rm_fuel2">Dầu Diesel</label>
							</div>
							<div className="custom-radio">
								<input
									type="radio"
									id="rm_fuel3"
									name="rdFuel"
									value="3"
									onChange={this.onFuelChange}
									checked={filter.fuel == 3}
								/>
								<label htmlFor="rm_fuel3">Điện</label>
							</div>
						</div>
					</div>

					{/* <div className="group-item">
						<div className="show-more pointer" onClick={this.toggleShowAdvance}>
							<p>{showAdvance ? "Ẩn lọc nâng cao" : "Hiển thị lọc nâng cao"}</p>
							<div className="wrap-svg">{showAdvance ? <IcHideAdvance /> : <IcAdvance />}</div>
						</div>
					</div> */}
						<>
							{/* {this.isSD && (
								<div className="group-item">
									<p className="title">Giới hạn số km</p>
									<div className="wrap-item">
										<div className="range-slider">
											<Slider
												step={defLimitKMRange.step}
												min={minLimitKM}
												max={maxLimitKM}
												value={filter.limitKM}
												handleStyle={handleSliderSt}
												trackStyle={trackSt}
												railStyle={railSt}
												onChange={this.onLimitKMRangeChange}
												onChangeComplete={this.onLimitKMRangeChangeComplete}
											/>
										</div>

										<div className="range-value">
											<div className="range-value__item">
												<p>
													{filter.limitKM < maxLimitKM &&
														filter.limitKM > minLimitKM &&
														`Trên ${filter.limitKM}km/ngày`}
													{filter.limitKM <= minLimitKM && `Bất kì`}
													{filter.limitKM >= maxLimitKM && `Không giới hạn`}
												</p>
											</div>
										</div>
									</div>

									<div className="line-page" />

									{filter.limitKM > minLimitKM && (
										<>
											<div className="group-item">
												<p className="title">Phí vượt giới hạn</p>
												<div className="wrap-item">
													<div className="range-slider">
														<Slider
															step={defLimitKMPriceRange.step}
															min={minLimitKMPrice}
															max={maxLimitKMPrice}
															value={filter.limitKMPrice}
															handleStyle={handleSliderSt}
															trackStyle={trackSt}
															railStyle={railSt}
															onChange={this.onLimitKMPriceRangeChange}
															onChangeComplete={this.onLimitKMPriceRangeChangeComplete}
														/>
													</div>
													<div className="range-value">
														<div className="range-value__item">
															<p>
																{filter.limitKMPrice < maxLimitKMPrice &&
																	filter.limitKMPrice > minLimitKMPrice &&
																	`Từ dưới ${filter.limitKMPrice}K/km`}
																{filter.limitKMPrice <= minLimitKMPrice && `Miễn phí`}
																{filter.limitKMPrice >= maxLimitKMPrice && `Bất kì`}
															</p>
														</div>
													</div>
												</div>
											</div>
											<div className="line-page" />
										</>
									)}

								
								</div>
							)} */}
							{/* --> */}
							{/* {mode === viewModes.LIST && (
								<>
									<div className="group-item">
										<p className="title">Khoảng cách</p>
										<div className="wrap-item">
											<div className="range-slider">
												<Slider
													step={defRadiusRange.step}
													min={minRadius}
													max={maxRadius}
													value={filter.radius * 1.60934 <= maxRadius ? filter.radius * 1.60934 : maxRadius}
													handleStyle={handleSliderSt}
													trackStyle={trackSt}
													railStyle={railSt}
													onChange={this.onRadiusRangeChange}
													onChangeComplete={this.onRadiusRangeChangeComplete}
												/>
											</div>
											<div className="range-value">
												<div className="range-value__item">
													<p>
														{filter.radius * 1.60934 < maxRadius
															? `Trong vòng ${Math.round(filter.radius * 1.60934)} km`
															: "Bất kì"}
													</p>
												</div>
											</div>
										</div>
									</div>
									<div className="line-page" />
								</>
							)} */}

							{/* <div className="group-item">
								<p className="title">Số chỗ</p>
								<div className="wrap-item">
									<div className="range-slider">
										<Range
											min={minSeat}
											max={maxSeat}
											value={[filter.minSeat, filter.maxSeat]}
											allowCross={false}
											pushable={true}
											handleStyle={handleSliderSt}
											trackStyle={trackSt}
											railStyle={railSt}
											onChange={this.onSeatRangeChange}
											onAfterChange={this.onSeatRangeAfterChange}
										/>
									</div>

									<div className="range-value two-item">
										<div className="range-value__item">
											<span>Tối thiểu</span>
											<p>{filter.minSeat > minSeat ? filter.minSeat : minSeat}</p>
										</div>
										<div className="line" />
										<div className="range-value__item">
											{" "}
											<span>Tối đa</span>
											<p>{filter.maxSeat < maxSeat ? filter.maxSeat : maxSeat}</p>
										</div>
									</div>
								</div>
							</div> */}

							{/* <div className="line-page" /> */}

							{/* <div className="group-item">
								<p className="title">Năm sản xuất</p>
								<div className="wrap-item">
									<div className="range-slider">
										<Range
											min={minYear}
											max={maxYear}
											value={[filter.minYear, filter.maxYear]}
											allowCross={false}
											pushable={true}
											handleStyle={handleSliderSt}
											trackStyle={trackSt}
											railStyle={railSt}
											onChange={this.onYearRangeChange}
											onAfterChange={this.onYearRangeAfterChange}
										/>
									</div>
									<div className="range-value two-item">
										<div className="range-value__item">
											<span>Tối thiểu</span>
											<p>{filter.minYear > minYear ? filter.minYear : minYear}</p>
										</div>
										<div className="line" />
										<div className="range-value__item">
											{" "}
											<span>Tối đa</span>
											<p>{filter.maxYear < maxYear ? filter.maxYear : maxYear}</p>
										</div>
									</div>
								</div>
							</div> */}

							{/* {filter.directDelivery && (
								<>
								<div className="line-page" />
								<div className="group-item">
									<p className="title">{this.isSD ? " Phí giao nhận xe" : " Phí đưa đón"}</p>
									<div className="wrap-item">
										<div className="range-slider">
											<Slider
												step={defDPriceRange.step}
												min={minDPrice}
												max={maxDPrice}
												value={filter.dPrice}
												handleStyle={handleSliderSt}
												trackStyle={trackSt}
												railStyle={railSt}
												onChange={this.onDPriceRangeChange}
												onChangeComplete={this.onDPriceRangeChangeComplete}
											/>

											<div className="range-value">
												<div className="range-value__item">
													<p>
														{filter.dPrice < maxDPrice && filter.dPrice > minDPrice && `Từ dưới ${filter.dPrice}K/km`}
														{filter.dPrice <= minDPrice && `Miễn phí`}
														{filter.dPrice >= maxDPrice && `Bất kì`}
													</p>
												</div>
											</div>
										</div>
									</div>
								</div>
								</>
							)} */}
							{/* <div className="line-page" />
							<div className="group-item">
								<p className="title">Mức tiêu thụ nhiên liệu</p>
								<div className="wrap-item">
									<div className="range-slider space">
										<Slider
											step={defFuelCRange.step}
											min={minFuelC}
											max={maxFuelC}
											value={filter.fuelC}
											handleStyle={handleSliderSt}
											trackStyle={trackSt}
											railStyle={railSt}
											onChange={this.onFuelCRangeChange}
											onChangeComplete={this.onFuelCRangeChangeComplete}
										/>
									</div>
									<div className="range-value">
										<div className="range-value__item">
											<p>
												{filter.fuelC <= maxFuelC && filter.fuelC > minFuelC && `Từ dưới ${filter.fuelC}l/100km`}
												{filter.fuelC <= minFuelC && `Bất kì`}
											</p>
										</div>
									</div>
								</div>
							</div> */}
							{/* <div className="line-page" /> */}
							{/* <div className="group-item">
								<p className="title">Tính năng</p>
								<div className="wrap-item column-2">
									{customFilterConfig && (
										<CheckBoxFilter
											id="cb-feature-sb"
											options={customFilterConfig.allFeatures}
											onOptionChange={this.onFeaturesChange}
										/>
									)}
								</div>
							</div> */}
						</>
				</div>
			</div>
		);
	}
}

export default CSFilterScreen;
